export default "__VITE_ASSET__Qm37alt2__"